import { CSSProperties } from 'react';

import { useHistory } from 'react-router-dom';
import { DateTime } from 'luxon';

import './ActivityItem.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  title: string;
  date: string;
  path: string;
}

const ActivityItem: React.FC<Props> = ({ style, title, date, path }) => {
  const history = useHistory();
  return (
    <div onClick={() => history.push(path)} className="activity-item-container" style={style}>
      <p className="activity-date">{DateTime.fromISO(date).toFormat('dd/MM')}</p>
      <p>{title}</p>
    </div>
  );
};

export default ActivityItem;
